// Scene resolution for the BPM TV surface: picks the elevation grid, filters pins/flags,
// and builds the legend object from model state.
//
// Port of two legacy paths that intentionally DIFFER (kept 1:1, see tv-chart.md § Рендеринг):
//   mode 'render'    — `renderChart` (L58-141): filters pins/flags by meanList for a specific
//                      elevation value, and uses the question-variant / batch specific legend text.
//   mode 'elevation' — `change:tvElevationsRepresentValue` listener (L326-368): does NOT filter
//                      (full pins/flags per all-or-empty rule) and uses the generic entity/attribute
//                      legend text. This is a legacy inconsistency we reproduce deliberately.

import {
  attributeLegendText,
  batchLegendText,
  entityLegendText,
  variantLegendText
} from '@aytm/app/stats/page/question-views/bpm/components/tv/components/chart/lib/tvLegend'

const legend = (title, grid) => ({
  title,
  min: grid.heightMin,
  max: grid.heightMax,
  bricks: grid.heightTicks
})

export const resolveScene = ({
  answer,
  tvPlotByValue,
  tvElevationsRepresentValue,
  defaultValues,
  pins,
  flags,
  questionVariants = [],
  batches = [],
  mode = 'render'
}) => {
  const geoData = answer?.mds?.geoData
  if (!geoData) return null

  if (tvPlotByValue === 'e') {
    let v = Number(tvElevationsRepresentValue)
    if (Number.isNaN(v)) v = Number(defaultValues.e.e)

    const isAll = v === -1
    const grid = geoData.brand[isAll ? 'all' : `qv${v}`]

    const outPins = isAll ? pins : []
    let outFlags
    let title
    if (mode === 'render') {
      outFlags = isAll ? flags : flags.filter(el => answer.meanList?.[`qv${v}`]?.[`b${el.branchId}`] != null)
      title = isAll ? entityLegendText(answer) : variantLegendText(questionVariants[v - 1])
    } else {
      outFlags = flags
      title = entityLegendText(answer)
    }

    return { data: grid.points, pins: outPins, flags: outFlags, legend: legend(title, grid) }
  }

  if (tvPlotByValue === 'a') {
    let v = Number(tvElevationsRepresentValue)
    if (Number.isNaN(v)) v = Number(defaultValues.e.a)

    const isAll = v === -2
    const grid = geoData.attr[isAll ? 'all' : `b${v}`]

    const outFlags = isAll ? flags : []
    let outPins
    let title
    if (mode === 'render') {
      outPins = isAll ? pins : pins.filter(el => answer.meanList?.[`qv${el.questionVariantId}`]?.[`b${v}`] != null)
      title = isAll ? attributeLegendText(answer) : batchLegendText(batches[v - 1])
    } else {
      outPins = pins
      title = attributeLegendText(answer)
    }

    return { data: grid.points, pins: outPins, flags: outFlags, legend: legend(title, grid) }
  }

  // No plot-by selected: total entity surface (legacy `else` branch L105-112)
  const grid = geoData.brand.all
  return { data: grid.points, pins, flags, legend: legend(entityLegendText(answer), grid) }
}
